import React from "react";
import ManualTankTable from "./components/ManualTankTable";

const TankManualVolume = () => {
  return <ManualTankTable />;
};

export default TankManualVolume;
